import './src/main.css'
import BorderBox10 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox10.name, BorderBox10)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox10/index.js